import {
  MolsonBox,
  MolsonSpinner,
  MolsonTypography
} from '@components/reusable'

export const DataLoadingPlaceholder = ({
  text = 'Loading data'
}: {
  text: string
}) => {
  return (
    <MolsonBox
      alignItems="center"
      display="flex"
      flexDirection="column"
      gap={2}
      justifyContent="center"
      width="100%"
      data-testid="loading-spinner"
      position="fixed"
      top="50%"
      left="50%"
      sx={{ transform: 'translate(-50%, -50%)' }}
    >
      <MolsonSpinner
        sx={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center'
        }}
        size="5rem"
      />
      <MolsonTypography variant="h2">{text}</MolsonTypography>
    </MolsonBox>
  )
}
